// extracted by mini-css-extract-plugin
export default {"page_loading":"Loading_page_loading__be-5P","rotate4":"Loading_rotate4__kljpU","dash4":"Loading_dash4__GWKuv","spinner":"Loading_spinner__JL3na","fade":"Loading_fade__uGtdt"};